import { render, staticRenderFns } from "./review_list.vue?vue&type=template&id=08b2c2a1&scoped=true"
import script from "./review_list.vue?vue&type=script&lang=js"
export * from "./review_list.vue?vue&type=script&lang=js"
import style0 from "./review_list.vue?vue&type=style&index=0&id=08b2c2a1&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/product-detail.less?vue&type=style&index=1&id=08b2c2a1&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2c2a1",
  null
  
)

export default component.exports